// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-container[data-v-be6b7bae] {\n  white-space: nowrap;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n.scroll-container[data-v-be6b7bae]  .el-scrollbar__bar {\n  bottom: 0px;\n}\n.scroll-container[data-v-be6b7bae]  .el-scrollbar__wrap {\n  height: 49px;\n}", ""]);
// Exports
module.exports = exports;
